import './App.css';
import Tela01 from './components/tela01/Tela01';
import Tela02 from './components/tela02/Tela02';
import Tela03 from './components/tela03/Tela03';
import Tela04 from './components/tela04/Tela04';

function App() {
  return (
    <div>
      <Tela01 />
      <Tela02 />
      <Tela03 />
      <Tela04 />
      {/* <Tela05 /> */}
    </div>
  );
}

export default App;
